import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
            meta: {
                title: 'Home',
                icon: 'home',
                main: true,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue'),
            meta: {
                title: 'Login',
                icon: 'lock',
                main: false,
                secure: false,
                showMenu: false
            }
        },
        {
            path: '/researches',
            name: 'researches',
            component: () => import('./views/Researches.vue'),
            meta: {
                title: 'Researches',
                icon: 'book',
                main: true,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/researches/new',
            name: 'researchAdd',
            component: () => import('./views/ResearchAdd.vue'),
            meta: {
                title: 'ResearchAdd',
                icon: 'group',
                main: false,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/researches/:researchId',
            name: 'research',
            component: () => import('./views/Research.vue'),
            meta: {
                title: 'Research',
                icon: 'book',
                main: false,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/species',
            name: 'species',
            component: () => import('./views/Species.vue'),
            meta: {
                title: 'Species',
                icon: 'group',
                main: true,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/import',
            name: 'import',
            component: () => import('./views/Import.vue'),
            meta: {
                title: 'Import',
                icon: 'upload',
                main: true,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/species/new',
            name: 'speciesAdd',
            component: () => import('./views/SpeciesAdd.vue'),
            meta: {
                title: 'AddSpecies',
                icon: 'group',
                main: false,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/species/:speciesId',
            name: 'speciesSingle',
            component: () => import('./views/SpeciesSingle.vue'),
            meta: {
                title: 'SpeciesSingle',
                icon: 'group',
                main: false,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/species/:speciesId/edit',
            name: 'speciesEdit',
            component: () => import('./views/SpeciesEdit.vue'),
            meta: {
                title: 'EditSpecies',
                icon: 'group',
                main: false,
                secure: false,
                showMenu: true
            }
        },
        {
            path: '/401',
            component: () => import('./views/401.vue'),
            meta: {
                title: 'nopermission',
                icon: null,
                main: false,
                secure: false,
                showMenu: false
            }
        },
        {
            path: '*',
            component: () => import('./views/404.vue'),
            meta: {
                title: 'notfound',
                icon: null,
                main: false,
                secure: false,
                showMenu: false
            }
        }

    ]
})
